import React, { useState } from "react";
import {
  Box,
  TextField,
  Typography,
  Button,
  Avatar,
  Divider,
  Paper,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";

const CommentSection = () => {
  const [comment, setComment] = useState("");
  const [comments, setComments] = useState([
    {
      name: "Jane Doe",
      avatar: "https://i.pravatar.cc/150?img=3",
      text: "This project is such a powerful initiative — happy to support!",
      date: "Oct 9, 2025",
    },
    {
      name: "Carlos M.",
      avatar: "https://i.pravatar.cc/150?img=8",
      text: "The water infrastructure upgrade made a real impact in our community.",
      date: "Oct 8, 2025",
    },
  ]);

  const handlePost = () => {
    if (!comment.trim()) return;
    const newComment = {
      name: "You",
      avatar: "https://i.pravatar.cc/150?u=currentuser",
      text: comment,
      date: new Date().toLocaleDateString(),
    };
    setComments([newComment, ...comments]);
    setComment("");
  };

  return (
    <Box
      sx={{
        mt: 6,
        p: { xs: 2, md: 3 },
        borderRadius: 3,
        backgroundColor: "#fafafa",
        boxShadow: 2,
      }}
      id="comment-section"
    >
      {/* HEADER */}
      <Typography
        variant="h6"
        fontWeight={600}
        sx={{ mb: 2, color: "text.primary" }}
      >
        Comments
      </Typography>

      {/* POST BOX */}
      <Paper
        elevation={0}
        sx={{
          p: 2,
          mb: 3,
          display: "flex",
          alignItems: "flex-start",
          gap: 2,
          borderRadius: 2,
          backgroundColor: "white",
        }}
      >
        <Avatar
          alt="User"
          src="https://i.pravatar.cc/150?u=currentuser"
          sx={{ width: 48, height: 48 }}
        />
        <Box sx={{ flex: 1 }}>
          <TextField
            multiline
            fullWidth
            minRows={2}
            placeholder="Write a comment..."
            variant="outlined"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
          />
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}>
            <Button
              variant="contained"
              endIcon={<SendIcon />}
              sx={{
                borderRadius: 8,
                textTransform: "none",
                fontWeight: 600,
              }}
              onClick={handlePost}
            >
              Post Comment
            </Button>
          </Box>
        </Box>
      </Paper>

      <Divider sx={{ mb: 2 }} />

      {/* COMMENT LIST */}
      <Box>
        {comments.map((item, index) => (
          <Box
            key={index}
            sx={{
              display: "flex",
              alignItems: "flex-start",
              gap: 2,
              mb: 3,
              p: 2,
              borderRadius: 2,
              backgroundColor: "white",
              boxShadow: 1,
            }}
          >
            <Avatar alt={item.name} src={item.avatar} />
            <Box>
              <Typography variant="subtitle2" fontWeight={600}>
                {item.name}
              </Typography>
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ display: "block", mb: 1 }}
              >
                {item.date}
              </Typography>
              <Typography variant="body2">{item.text}</Typography>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default CommentSection;
